import * as React from 'react';
import styles from '../styles/wizards/EditSubstageWizard.scss';
import EditIcon from '../assets/images/edit-16x16.svg';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { updateSubstage } from '../redux/actions/table/substages';
import { readStage, listProjectSubstages } from '../redux/actions/table/stages';
import EditSubstageForm from '../forms/edit_substage_wizard/EditSubstageForm';
import moment from 'moment';

const EditSubstageWizard = ({ onClose, table, stage_id, match }) => {
  const data = table.edit_substage_wizard;

  const _handleSubmit = (formData) => {
    const nextDate = {
      ...data?.date,
      ...formData?.date,
    };

    if (nextDate?.start && nextDate?.end) {
      const start = moment(nextDate.start).startOf('day');
      const end = moment(nextDate.end).startOf('day');
      const durationDays = end.diff(start, 'days') + 1;
      nextDate.duration = `${durationDays}d`;
    }

    return validateForm(
      // updateSubstage(data.id, formData).then(() => {
      updateSubstage(data.id, { ...formData, date: nextDate }).then(() => {
        readStage(data.stage_id);
        listProjectSubstages(match.params.project);

        onClose();

        setNotification(__('wizard.edit-substage.notification.success'));
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.edit-substage.title.edit')}</span>
          <span>{__('wizard.edit-substage.subtitle.edit')}</span>
        </div>
        <div className={styles.right}>
          <EditIcon />
        </div>
      </div>
      <div className={styles.body}>
        <EditSubstageForm
          onSubmit={_handleSubmit}
          initialValues={{
            ...data,
            projectLanguages: data.languages,
            // stage_id: substage.stage_id,
            // name: substage.name,
            // description: substage.description,
            // status: substage.status.toString(),
            // // duration: substage.duration,
            // // date: {
            // //   start: substage.start_date,
            // //   end: substage.end_date,
            // // },
            // date: {
            //   start: substage.date?.start,
            //   end: substage.date?.end,
            //   allDay: substage.date?.allDay,
            //   duration: substage.date?.duration,
            //   deadline: substage.date?.deadline,
            // },
            // time_log: {
            //   planned_time: substage.time_log?.planned_time,
            // },
          }}
        />
      </div>
    </>
  );
};

export default withRouter(
  mapStateToProps((state) => ({
    table: state.table['substages'],
  }))(EditSubstageWizard)
);
